<div class="news-grid">
  @if (dataLoaded) {
    @for (newsItem of newsItems; track newsItem) {
      <app-news-item
        class="d-block"
        [newsItem]="newsItem"
        [useLazyLoad]="true"
      ></app-news-item>
    }
  }
</div>
@if (dataLoaded && newsItems && newsItems.length && totalItems > 10) {
  <a
  class="
    btn btn-dark
    rounded
    clickable
    withOpacity
    fw-bold
    my-2
    mb-5
    mx-auto
  "
    [routerLink]="'/' + selectedCompanyGroup + '/news'"
    >{{ "SHOW_MORE" | translate }}</a
    >
  }
